import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import "@fortawesome/fontawesome-svg-core/styles.css";

//KOMPONENTA SE KORISTI SAMO KAD SE ULOGUJE A U LOGIN JE CUSTOM
const LandingFooter = () => {
  const { username, status } = useAuth();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onGoHomeClicked = () => navigate("/dash");
  const onGoTermsClicked = () => navigate("/terms");
  const onGoHelpClicked = () => navigate("/help");

  let goHomeButton = null;
  if (pathname !== "/dash") {
    goHomeButton = (
      <button
        className="dash-footer__button icon-button"
        title="Home"
        onClick={onGoHomeClicked}
      >
        <FontAwesomeIcon icon={faHouse} />
      </button>
    );
  }

  const content = (
    <footer className="dash-footer">
      {goHomeButton}
      <p>Current User: {username}</p>
      <p>Status: {status}</p>
    </footer>
  );

  //==== Ka dole ====

  const footerNavigation = {
    main: [
      { name: "Blog", href: "#" },
      { name: "Jobs", href: "#" },
      { name: "Press", href: "#" },
      { name: "Accessibility", href: "#" },
      { name: "Partners", href: "#" },
    ],
    social: [
      {
        name: "Facebook",
        href: "#",
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path
              fillRule="evenodd"
              d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
              clipRule="evenodd"
            />
          </svg>
        ),
      },
      {
        name: "Instagram",
        href: "#",
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path
              fillRule="evenodd"
              d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
              clipRule="evenodd"
            />
          </svg>
        ),
      },
      {
        name: "TikTok",
        href: "#",
        icon: FontAwesomeIcon,
      },
      {
        name: "YouTube",
        href: "#",
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path
              fillRule="evenodd"
              d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
              clipRule="evenodd"
            />
          </svg>
        ),
      },
    ],
  };

  //OVAJ KORISTIM

  const footerDiv = (
    <>
      {/* Footer mora inline style jer nece da mi aplajuje preko tailwinda*/}
      <footer
        className="fixed inset-x-0 bottom-0 z-50 w-full px-4 sm:px-6 lg:px-8 pb-4 sm:pb-2 lg:pb-2"
        style={{ backgroundColor: "#66BB6A" }}
      >
        {/* Navigation links for footer */}
        {/* <nav
          className="flex flex-col items-center sm:flex-row sm:justify-center sm:space-x-12"
          aria-label="Footer"
        >
          {footerNavigation.main.map((item) => (
            <div key={item.name} className="pb-2 sm:pb-0">
              <a
                href={item.href}
                className="text-sm leading-6 text-white hover:text-gray-300"
              >
                {item.name}
              </a>
            </div>
          ))}
        </nav> */}

        {/* Social media icons for footer */}
        <div className="mt-3 flex justify-center space-x-4 sm:space-x-6 lg:space-x-10">
          {footerNavigation.social.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="text-gray-300 hover:text-gray-100"
            >
              <span className="sr-only">{item.name}</span>
              {/* Render the icon component properly */}
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </a>
          ))}
        </div>

        {/* Footer copyright information */}
        <p className="mt-2 text-center text-xs leading-5 text-gray-300">
          &copy; 2024 NutriTrans. Sva prava zadržana.
        </p>
      </footer>
    </>
  );

  const footerNew = (
    <>
      <footer className="bg-gray-900 text-white py-12 px-4 font-sans tracking-wide">
        <div className="text-center">
          <ul className="flex flex-wrap justify-center gap-x-8 gap-4 mt-8 mb-12">
            {/* Facebook */}
            <li>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  fill="#1877F2"
                  width="32px"
                  height="32px"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14,6h3a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H14A5,5,0,0,0,9,7v3H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9v7a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14h2.22a1,1,0,0,0,1-.76l.5-2a1,1,0,0,0-1-1.24H13V7A1,1,0,0,1,14,6Z"
                    fill="#1877F2"
                  />
                </svg>
              </a>
            </li>

            {/* Instagram */}
            <li>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2 S9.103,10,8,10z M11,0H5C2.237,0,0,2.237,0,5v6c0,2.762,2.237,5,5,5h6c2.762,0,5-2.238,5-5V5C16,2.237,13.762,0,11,0z M14,11 c0,1.653-1.347,3-3,3H5c-1.653,0-3-1.347-3-3V5c0-1.653,1.347-3,3-3h6c1.653,0,3,1.347,3,3V11z M12,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1s1-0.447,1-1S12.553,3,12,3z"
                    fill="url(#instagramGradient)"
                  />
                  <defs>
                    <linearGradient
                      id="instagramGradient"
                      x1="0"
                      x2="1"
                      y1="0"
                      y2="1"
                    >
                      <stop offset="0%" stopColor="#F58529" />
                      <stop offset="50%" stopColor="#DD2A7B" />
                      <stop offset="100%" stopColor="#8134AF" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            </li>

            {/* YouTube */}
            <li>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.712 4.633a1.754 1.754 0 00-1.234-1.234C12.382 3.11 8 3.11 8 3.11s-4.382 0-5.478.289c-.6.161-1.072.634-1.234 1.234C1 5.728 1 8 1 8s0 2.283.288 3.367c.162.6.635 1.073 1.234 1.234C3.618 12.89 8 12.89 8 12.89s4.382 0 5.478-.289a1.754 1.754 0 001.234-1.234C15 10.272 15 8 15 8s0-2.272-.288-3.367z"
                    fill="#FF0000"
                  />
                  <path
                    d="M6.593 10.11l3.644-2.098-3.644-2.11v4.208z"
                    fill="#FFFFFF"
                  />
                </svg>
              </a>
            </li>

            {/* TikTok */}
            <li>
              <a
                href="https://www.tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32px"
                  height="32px"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
                    fill="url(#tiktokGradient)"
                  />
                  <defs>
                    <linearGradient
                      id="tiktokGradient"
                      x1="0"
                      x2="1"
                      y1="0"
                      y2="1"
                    >
                      <stop offset="0%" stopColor="#25F4EE" />
                      <stop offset="50%" stopColor="#FE2C55" />
                      <stop offset="100%" stopColor="#FFC40C" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            </li>
          </ul>

          <p className="text-base text-gray-300">
            © ReadymadeUI. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );

  const footerApply = (
    <>
      {/* Footer mora inline style jer nece da mi aplajuje preko tailwinda*/}
      <footer
        className="fixed inset-x-0 bottom-0 z-50 w-full px-4 sm:px-6 lg:px-8 pb-4 sm:pb-2 lg:pb-2"
        style={{ backgroundColor: "#66BB6A" }}
      >
        {/* Social media icons for footer */}
        <div className="mt-3 flex justify-center space-x-4 sm:space-x-6 lg:space-x-10">
          <ul className="flex flex-wrap justify-center gap-x-8 gap-4 mt-3">
            {/* Facebook */}
            <li>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  fill="#1877F2"
                  width="32px"
                  height="32px"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14,6h3a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H14A5,5,0,0,0,9,7v3H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9v7a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14h2.22a1,1,0,0,0,1-.76l.5-2a1,1,0,0,0-1-1.24H13V7A1,1,0,0,1,14,6Z"
                    fill="#1877F2"
                  />
                </svg>
              </a>
            </li>

            {/* Instagram */}
            <li>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2 S9.103,10,8,10z M11,0H5C2.237,0,0,2.237,0,5v6c0,2.762,2.237,5,5,5h6c2.762,0,5-2.238,5-5V5C16,2.237,13.762,0,11,0z M14,11 c0,1.653-1.347,3-3,3H5c-1.653,0-3-1.347-3-3V5c0-1.653,1.347-3,3-3h6c1.653,0,3,1.347,3,3V11z M12,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1s1-0.447,1-1S12.553,3,12,3z"
                    fill="url(#instagramGradient)"
                  />
                  <defs>
                    <linearGradient
                      id="instagramGradient"
                      x1="0"
                      x2="1"
                      y1="0"
                      y2="1"
                    >
                      <stop offset="0%" stopColor="#F58529" />
                      <stop offset="50%" stopColor="#DD2A7B" />
                      <stop offset="100%" stopColor="#8134AF" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            </li>

            {/* YouTube */}
            <li>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.712 4.633a1.754 1.754 0 00-1.234-1.234C12.382 3.11 8 3.11 8 3.11s-4.382 0-5.478.289c-.6.161-1.072.634-1.234 1.234C1 5.728 1 8 1 8s0 2.283.288 3.367c.162.6.635 1.073 1.234 1.234C3.618 12.89 8 12.89 8 12.89s4.382 0 5.478-.289a1.754 1.754 0 001.234-1.234C15 10.272 15 8 15 8s0-2.272-.288-3.367z"
                    fill="#FF0000"
                  />
                  <path
                    d="M6.593 10.11l3.644-2.098-3.644-2.11v4.208z"
                    fill="#FFFFFF"
                  />
                </svg>
              </a>
            </li>

            {/* TikTok */}
            <li>
              <a
                href="https://www.tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32px"
                  height="32px"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
                    fill="url(#tiktokGradient)"
                  />
                  <defs>
                    <linearGradient
                      id="tiktokGradient"
                      x1="0"
                      x2="1"
                      y1="0"
                      y2="1"
                    >
                      <stop offset="0%" stopColor="#25F4EE" />
                      <stop offset="50%" stopColor="#FE2C55" />
                      <stop offset="100%" stopColor="#FFC40C" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            </li>
          </ul>
        </div>

        {/* Footer copyright information */}
        <p className="mt-2 text-center text-xs leading-5 text-gray-300">
          &copy; 2024 NutriTrans. Sva prava zadržana.
        </p>
      </footer>
    </>
  );

  const footerApply_ = (
    <>
      <footer
        className="fixed inset-x-0 bottom-0 z-50 w-full px-4 sm:px-6 lg:px-8 pb-4 sm:pb-2 lg:pb-2"
        style={{ backgroundColor: "#66BB6A" }}
      >
        <div className="flex items-center justify-between">
          {/* Leva strana - Link */}
          <a
            href="/"
            className="text-white text-sm font-semibold cursor-pointer"
          >
            Link 1
          </a>

          {/* Središnja komponenta - Fleksibilno centrirana */}
          <div className="flex-1 flex flex-col items-center ml-5">
            {/* Social media icons for footer */}
            <div className="mt-3 flex justify-center space-x-4 sm:space-x-6 lg:space-x-10">
              <ul className="flex flex-wrap justify-center gap-x-8 gap-4 mt-3">
                {/* Facebook */}
                <li>
                  <a
                    href="https://www.facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      fill="#1877F2"
                      width="32px"
                      height="32px"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14,6h3a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H14A5,5,0,0,0,9,7v3H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9v7a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14h2.22a1,1,0,0,0,1-.76l.5-2a1,1,0,0,0-1-1.24H13V7A1,1,0,0,1,14,6Z"
                        fill="#1877F2"
                      />
                    </svg>
                  </a>
                </li>

                {/* Instagram */}
                <li>
                  <a
                    href="https://www.instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      width="32px"
                      height="32px"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2 S9.103,10,8,10z M11,0H5C2.237,0,0,2.237,0,5v6c0,2.762,2.237,5,5,5h6c2.762,0,5-2.238,5-5V5C16,2.237,13.762,0,11,0z M14,11 c0,1.653-1.347,3-3,3H5c-1.653,0-3-1.347-3-3V5c0-1.653,1.347-3,3-3h6c1.653,0,3,1.347,3,3V11z M12,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1s1-0.447,1-1S12.553,3,12,3z"
                        fill="url(#instagramGradient)"
                      />
                      <defs>
                        <linearGradient
                          id="instagramGradient"
                          x1="0"
                          x2="1"
                          y1="0"
                          y2="1"
                        >
                          <stop offset="0%" stopColor="#F58529" />
                          <stop offset="50%" stopColor="#DD2A7B" />
                          <stop offset="100%" stopColor="#8134AF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                </li>

                {/* YouTube */}
                <li>
                  <a
                    href="https://www.youtube.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      width="32px"
                      height="32px"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.712 4.633a1.754 1.754 0 00-1.234-1.234C12.382 3.11 8 3.11 8 3.11s-4.382 0-5.478.289c-.6.161-1.072.634-1.234 1.234C1 5.728 1 8 1 8s0 2.283.288 3.367c.162.6.635 1.073 1.234 1.234C3.618 12.89 8 12.89 8 12.89s4.382 0 5.478-.289a1.754 1.754 0 001.234-1.234C15 10.272 15 8 15 8s0-2.272-.288-3.367z"
                        fill="#FF0000"
                      />
                      <path
                        d="M6.593 10.11l3.644-2.098-3.644-2.11v4.208z"
                        fill="#FFFFFF"
                      />
                    </svg>
                  </a>
                </li>

                {/* TikTok */}
                <li>
                  <a
                    href="https://www.tiktok.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32px"
                      height="32px"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
                        fill="url(#tiktokGradient)"
                      />
                      <defs>
                        <linearGradient
                          id="tiktokGradient"
                          x1="0"
                          x2="1"
                          y1="0"
                          y2="1"
                        >
                          <stop offset="0%" stopColor="#25F4EE" />
                          <stop offset="50%" stopColor="#FE2C55" />
                          <stop offset="100%" stopColor="#FFC40C" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>

            {/* Copyright text - centriran */}
            <p className="mt-2 text-center text-xs leading-5 text-gray-300">
              &copy; 2024 NutriTrans. Sva prava zadržana.
            </p>
          </div>

          {/* Desna strana - Link */}
          <button
            onClick={onGoTermsClicked}
            className="text-black text-sm font-semibold cursor-pointer border-2 border-black bg-white py-2 px-4"
          >
            Uslovi korišćenja
          </button>
        </div>
      </footer>
    </>
  );

  const footerApply_1 = (
    <>
      <footer
        className="fixed inset-x-0 bottom-0 z-50 w-full px-2 sm:px-4 md:px-6 lg:px-8 pb-3 sm:pb-2"
        style={{ backgroundColor: "#66BB6A" }}
      >
        <div className="flex flex-wrap items-center justify-between gap-2 sm:gap-4 md:gap-6">
          {/* Leva strana - Link (smanjuje se na manjim ekranima) */}
          <a
            href="/"
            className="text-white text-xs sm:text-sm md:text-base font-semibold cursor-pointer px-2 sm:px-4"
          >
            Pomoć
          </a>

          {/* Središnja komponenta - Fleksibilno centrirana */}
          <div className="flex-1 flex flex-col items-center">
            {/* Social media icons for footer */}
            <div className="mt-3 flex justify-center space-x-4 sm:space-x-6 lg:space-x-10">
              <ul className="flex flex-wrap justify-center gap-x-8 gap-4 mt-3">
                {/* Facebook */}
                <li>
                  <a
                    href="https://www.facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      fill="#1877F2"
                      width="32px"
                      height="32px"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14,6h3a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H14A5,5,0,0,0,9,7v3H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9v7a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14h2.22a1,1,0,0,0,1-.76l.5-2a1,1,0,0,0-1-1.24H13V7A1,1,0,0,1,14,6Z"
                        fill="#1877F2"
                      />
                    </svg>
                  </a>
                </li>

                {/* Instagram */}
                <li>
                  <a
                    href="https://www.instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      width="32px"
                      height="32px"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2 S9.103,10,8,10z M11,0H5C2.237,0,0,2.237,0,5v6c0,2.762,2.237,5,5,5h6c2.762,0,5-2.238,5-5V5C16,2.237,13.762,0,11,0z M14,11 c0,1.653-1.347,3-3,3H5c-1.653,0-3-1.347-3-3V5c0-1.653,1.347-3,3-3h6c1.653,0,3,1.347,3,3V11z M12,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1s1-0.447,1-1S12.553,3,12,3z"
                        fill="url(#instagramGradient)"
                      />
                      <defs>
                        <linearGradient
                          id="instagramGradient"
                          x1="0"
                          x2="1"
                          y1="0"
                          y2="1"
                        >
                          <stop offset="0%" stopColor="#F58529" />
                          <stop offset="50%" stopColor="#DD2A7B" />
                          <stop offset="100%" stopColor="#8134AF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                </li>

                {/* YouTube */}
                <li>
                  <a
                    href="https://www.youtube.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      width="32px"
                      height="32px"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.712 4.633a1.754 1.754 0 00-1.234-1.234C12.382 3.11 8 3.11 8 3.11s-4.382 0-5.478.289c-.6.161-1.072.634-1.234 1.234C1 5.728 1 8 1 8s0 2.283.288 3.367c.162.6.635 1.073 1.234 1.234C3.618 12.89 8 12.89 8 12.89s4.382 0 5.478-.289a1.754 1.754 0 001.234-1.234C15 10.272 15 8 15 8s0-2.272-.288-3.367z"
                        fill="#FF0000"
                      />
                      <path
                        d="M6.593 10.11l3.644-2.098-3.644-2.11v4.208z"
                        fill="#FFFFFF"
                      />
                    </svg>
                  </a>
                </li>

                {/* TikTok */}
                <li>
                  <a
                    href="https://www.tiktok.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32px"
                      height="32px"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
                        fill="url(#tiktokGradient)"
                      />
                      <defs>
                        <linearGradient
                          id="tiktokGradient"
                          x1="0"
                          x2="1"
                          y1="0"
                          y2="1"
                        >
                          <stop offset="0%" stopColor="#25F4EE" />
                          <stop offset="50%" stopColor="#FE2C55" />
                          <stop offset="100%" stopColor="#FFC40C" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>

            {/* Copyright text - centriran */}
            <p className="mt-1 text-center text-[10px] sm:text-xs leading-5 text-gray-300">
              &copy; 2024 NutriTrans. Sva prava zadržana.{" "}
              <a
                href="mailto:office@nutritrans.com"
                className="text-blue-300 hover:text-blue-500"
              >
                Kontaktirajte nas
              </a>
            </p>
          </div>

          {/* Desna strana - Link (smanjuje se na manjim ekranima) */}
          <button
            onClick={onGoTermsClicked}
            className="text-white text-xs sm:text-sm md:text-base font-semibold cursor-pointer px-2 sm:px-4"
          >
            Uslovi korišćenja
          </button>
        </div>
      </footer>
    </>
  );

  const footerApply_2_copy = (
    <>
      <footer
        className="fixed inset-x-0 bottom-0 z-50 w-full px-2 sm:px-4 md:px-6 lg:px-8 pb-3 sm:pb-2"
        style={{ backgroundColor: "#66BB6A" }}
      >
        <div className="flex flex-wrap items-center justify-between gap-2 sm:gap-4 md:gap-6">
          {/* Leva strana - Link (smanjuje se na manjim ekranima) */}
          <button
            onClick={onGoHelpClicked}
            className="text-white text-xs"
            style={{
              border: "1px dashed #fff",
              borderRadius: "5px",
              padding: "1px",
            }}
          >
            Pomoć
          </button>

          {/* Središnja komponenta - Fleksibilno centrirana */}
          <div className="flex-1 flex flex-col items-center"></div>

          {/* Desna strana - Link (smanjuje se na manjim ekranima) */}
          <a
            onClick={onGoTermsClicked}
            className="text-white text-xs text-center md:inline-block block cursor-pointer"
            style={{
              border: "1px dashed #fff",
              borderRadius: "5px",
              padding: "1px",
            }}
          >
            Uslovi <br /> korišćenja
          </a>
        </div>
      </footer>
    </>
  );

  const footerApply_2 = (
    <>
      <footer
        className="fixed inset-x-0 bottom-0 z-50 w-full px-2 sm:px-4 md:px-6 lg:px-8 pb-3 sm:pb-2"
        style={{ backgroundColor: "#66BB6A" }}
      >
        <div className="flex flex-wrap items-center justify-between gap-2 sm:gap-4 md:gap-6">
          {/* Leva strana - Link (smanjuje se na manjim ekranima) */}
          <button
            onClick={onGoHelpClicked}
            className="text-white text-xs"
            style={{
              border: "1px dashed #fff",
              borderRadius: "5px",
              padding: "1px",
            }}
          >
            Pomoć
          </button>

          {/* Središnja komponenta - Fleksibilno centrirana */}
          <div className="flex-1 flex flex-col items-center">
            {/* Social media icons for footer */}
            <div className="mt-3 flex justify-center space-x-4 sm:space-x-6 lg:space-x-10">
              <ul className="flex flex-wrap justify-center gap-x-8 gap-4 mt-3">
                {/* Facebook */}
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=61572660100830"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      fill="#1877F2"
                      width="24px" // Adjusted size for mobile
                      height="24px"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14,6h3a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H14A5,5,0,0,0,9,7v3H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9v7a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14h2.22a1,1,0,0,0,1-.76l.5-2a1,1,0,0,0-1-1.24H13V7A1,1,0,0,1,14,6Z"
                        fill="#1877F2"
                      />
                    </svg>
                  </a>
                </li>

                {/* Instagram */}
                <li>
                  <a
                    href="https://www.instagram.com/nutritrans2025/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      width="24px" // Adjusted size for mobile
                      height="24px"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2 S9.103,10,8,10z M11,0H5C2.237,0,0,2.237,0,5v6c0,2.762,2.237,5,5,5h6c2.762,0,5-2.238,5-5V5C16,2.237,13.762,0,11,0z M14,11 c0,1.653-1.347,3-3,3H5c-1.653,0-3-1.347-3-3V5c0-1.653,1.347-3,3-3h6c1.653,0,3,1.347,3,3V11z M12,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1s1-0.447,1-1S12.553,3,12,3z"
                        fill="url(#instagramGradient)"
                      />
                      <defs>
                        <linearGradient
                          id="instagramGradient"
                          x1="0"
                          x2="1"
                          y1="0"
                          y2="1"
                        >
                          <stop offset="0%" stopColor="#F58529" />
                          <stop offset="50%" stopColor="#DD2A7B" />
                          <stop offset="100%" stopColor="#8134AF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                </li>

                {/* YouTube */}
                <li>
                  <a
                    href="https://www.youtube.com/@NutriTrans"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      width="24px" // Adjusted size for mobile
                      height="24px"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.712 4.633a1.754 1.754 0 00-1.234-1.234C12.382 3.11 8 3.11 8 3.11s-4.382 0-5.478.289c-.6.161-1.072.634-1.234 1.234C1 5.728 1 8 1 8s0 2.283.288 3.367c.162.6.635 1.073 1.234 1.234C3.618 12.89 8 12.89 8 12.89s4.382 0 5.478-.289a1.754 1.754 0 001.234-1.234C15 10.272 15 8 15 8s0-2.272-.288-3.367z"
                        fill="#FF0000"
                      />
                      <path
                        d="M6.593 10.11l3.644-2.098-3.644-2.11v4.208z"
                        fill="#FFFFFF"
                      />
                    </svg>
                  </a>
                </li>

                {/* TikTok */}
                <li>
                  <a
                    href="https://www.tiktok.com/@nutritrans2025"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px" // Adjusted size for mobile
                      height="24px"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
                        fill="url(#tiktokGradient)"
                      />
                      <defs>
                        <linearGradient
                          id="tiktokGradient"
                          x1="0"
                          x2="1"
                          y1="0"
                          y2="1"
                        >
                          <stop offset="0%" stopColor="#25F4EE" />
                          <stop offset="50%" stopColor="#FE2C55" />
                          <stop offset="100%" stopColor="#FFC40C" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>

            {/* Copyright text - centriran */}
            <p className="mt-1 text-center text-[10px] sm:text-xs leading-5 text-gray-300">
              &copy; {new Date().getFullYear()} NutriTrans. Sva prava zadržana.{" "}
              <a
                // href="mailto:office@nutritrans.com"
                className="text-blue-300 hover:text-blue-500 cursor-pointer"
              >
                office@nutritrans.com
              </a>
            </p>
          </div>

          {/* Desna strana - Link (smanjuje se na manjim ekranima) */}
          <a
            onClick={onGoTermsClicked}
            className="text-white text-xs text-center md:inline-block block cursor-pointer"
            style={{
              border: "1px dashed #fff",
              borderRadius: "5px",
              padding: "1px",
            }}
          >
            Uslovi <br /> korišćenja
          </a>
        </div>
      </footer>
    </>
  );

  return footerApply_2;
};
export default LandingFooter;
